import { useEffect, useState } from "react";
import { t } from "i18next";
import { useAppStore } from "../../../../../stores/RootStore";
import { DataRow, Tab } from "../../../../../stores/TabsStore";
import { Person } from "../../../../../types/types";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../../ui/Tabs/Tabs";
import { Separator } from "../../../../../ui/Separator";
import { ScrollArea } from "../../../../../ui/ScrollArea/ScrollArea";

import { PersonLoaded } from "./PersonLoaded";
import { LoadBarChart } from "./LoadBarChart";
import {EquipmentInteractions} from "./EquipmentInteractions"
import { DropdownMenu, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from "../../../../../ui/DropdownMenu/DropdownMenu";
import { Button } from "../../../../../ui/Button";


// import { PersonDay } from "./EquipmentDay";
// import EHeatMap from "./EHeatMap";
// import EGantt from "./EGantt";

// import { Losses } from "./Losses";

export function TemplateItem({tab}:{tab: Tab}) {
  const [loading, setLoading] = useState(true)
  const {persons} = useAppStore()
  const [currentItem, setCurrentItem] = useState<Person | null>(null)
  const [itemData, setItemData] = useState<DataRow[] | []>([])
  // const [by, setBy] = useState<"equipment" | "days" | string>("equipment")

  useEffect(() => {
    setLoading(true)
    setCurrentItem(persons?.find(p => p.id === tab.reportOptions.items[0])!)
    setItemData(tab.options?.reportData.filter(r => r.person?.id === tab.reportOptions.items[0])!)
  }, [tab.reportOptions.items[0]])

  useEffect(() => {
    setLoading(false)
  }, [itemData])

  return (
    <div className="flex flex-col w-full h-full overflow-hidden">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          <span className="text-2xl font-semibold">{currentItem?.attributes.last_name} {currentItem?.attributes.first_name} {currentItem?.attributes.middle_name}</span>
        </div>
      </div>
      
      <Separator />
      {loading ? <></> :
      <Tabs defaultValue={"common"} className="flex flex-col bg-background relative h-full w-full overflow-hidden">
        <TabsList className="flex-none h-12 w-full px-6 justify-start gap-2">
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="common">
            {t("common_info")}
          </TabsTrigger>
          {/* <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="heatmap">
            {t("heatmap")}
          </TabsTrigger>
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="losses">
            {t("losses")}
          </TabsTrigger>
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="violations">
            {t("violations")}
          </TabsTrigger> */}
        </TabsList>
        <Separator />
        <div className="flex flex-col w-full h-full justify-start relative overflow-hidden">
          <TabsContent className="flex flex-col min-w-[1008px] w-full data-[state=active]:h-full m-0" value="common">
            <ScrollArea>
              <div className="flex flex-col gap-2">
                <div className="px-6">
                  <PersonLoaded person={currentItem!} data={itemData!}/>
                </div>
                <div className="px-6 space-y-2">
                  <LoadBarChart data={itemData!}/>
                </div>
                <div className="px-6 h-full">
                  <EquipmentInteractions person={currentItem!} data={itemData!}/>
                </div>
              </div>
            </ScrollArea>
          </TabsContent>
          {/* <TabsContent className="flex flex-col w-full min-w-[808px] data-[state=active]:h-full m-0" value="heatmap">
            <ScrollArea>
              <div className="px-6 space-y-4 py-4">
                <div>{t('event_map')}</div>
                <EGantt data={itemData!}/>
                <div>{t('heat_map')}</div>
                <EHeatMap data={itemData!}/>
              </div>
            </ScrollArea>
          </TabsContent>
          <TabsContent className="flex flex-col w-full min-w-[808px] data-[state=active]:h-full m-0" value="losses">
            <ScrollArea>
              <div className="px-6 space-y-2">
                <Losses data={itemData!}/>
              </div>
            </ScrollArea>
          </TabsContent> */}
        </div>
      </Tabs>}

    </div>
  )
}